'use strict'

import Helper from '@/utils/helper'
import StatusTypes from '@/app/model/status/status-types'
import SaleInfo from '@/app/model/sale/sale-info'

class StatusResult {
  constructor({state, receiptUrl, saleInfo}) {
    if (Helper.isDefined(state) && !StatusTypes.isValidValue(state)) {
      throw new Error(`Incorrect StatusResult.state: ${state}`)
    }

    Helper.checkOptionalString('StatusResult.receiptUrl', receiptUrl)

    this.state = StatusTypes.fromValue(state)
    this.receiptUrl = Helper.getValue(receiptUrl)
    this.saleInfo = Helper.isDefined(saleInfo) ? new SaleInfo(saleInfo) : null
  }

  getState() {
    return this.state
  }

  getReceiptUrl() {
    return this.receiptUrl
  }

  getSaleInfo() {
    return this.saleInfo
  }

  toString() {
    return 'StatusResult{' +
      'state=' + '\'' + this.state + '\'' +
      ', receiptUrl=' + '\'' + this.receiptUrl + '\'' +
      ', saleInfo=' + '\'' + this.saleInfo + '\'' +
      '}'
  }
}

export default StatusResult
